//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function receive(content?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GDTMessageDto> {
    let url_ = getBaseUrl() + "/api/gdt/incoming-messages?";
    if (content === null)
        throw new Error("The parameter 'content' cannot be null.");
    else if (content !== undefined)
        url_ += "content=" + encodeURIComponent("" + content) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigReceive,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigReceive?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processReceive(_response);
    });
}

function processReceive(response: AxiosResponse): Promise<Types.GDTMessageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initGDTMessageDto(resultData200);
        return Promise.resolve<Types.GDTMessageDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GDTMessageDto>(null as any);
}
let _requestConfigReceive: Partial<AxiosRequestConfig> | null;
export function getReceiveRequestConfig() {
  return _requestConfigReceive;
}
export function setReceiveRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigReceive = value;
}
export function patchReceiveRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigReceive = patch(_requestConfigReceive ?? {});
}